import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../../components/WaveNavigation';

const Question = ({ children }) => (
  <p className='question'>
    <i className='fas fa-scrubber' /> {children}
  </p>
);
const Answer = ({ children }) => <p className='answer'>{children}</p>;
const Unit = ({ children }) => <div className='col-md-6'>{children}</div>;

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Freight FAQ'
      meta={[
        {
          name: 'description',
          content: 'Fire Island Freight Frequently Asked Questions',
        },
        {
          name: 'keywords',
          content: 'Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container page'>
      <div className='heading'>
        <h2>Freight FAQ</h2>
        <h1>Frequently Asked Freight Questions</h1>
      </div>
      <p>
        Below are some of the most frequently asked questions we have received.
        If you have a question or need some clarification, please call us at{' '}
        <i className='far fa-phone' /> 631.647.3055 or e-mail us at{' '}
        <i className='far fa-envelope' /> freight@fireislandferries.com
      </p>
      <div className='row mt-4'>
        <Unit>
          <Question>
            Does Fire Island Ferries accept deliveries from Instacart, Shipt,
            Pea Pod or Whole Foods?
          </Question>
          <Answer>
            No. We do not accept deliveries from any of these outfits. If
            attempted the order will be refused at the customers expense. None
            of these vendors protect, label or leave an invoice with us. Shop
            Rite in Bay Shore, King Kullen in Bay Shore, Pat's Market in East
            Islip, Rustic Roots Delivery, Uncle Giuseppe's Marketplace, and Sherry's Market in Babylon are the only stores that we
            accept delivery from. You can try ordering directly from Costco or
            BJ's websites to have those non-perishable items sent via UPS or
            FedEx.
          </Answer>
        </Unit>
        <Unit>
          <Question>Which grocery stores deliver to the freight boat?</Question>
          <Answer>
            Presently, Fire Island Ferries only accepts groceries from Shop
            Rite, King Kullen and Pat’s Market. They have accounts set up with
            us, and will cover the freight charge. Therefore, we can leave your
            cartons of groceries on the town dock that you have designated when
            placing your grocery order. It is recommended that you continue to
            order your groceries to be delivered to the freight boat before
            10:00 am Monday – Friday. Any further questions with regard to
            ordering groceries or estimated times that the freight boat will be
            in your town, please call the freight department at 631.647.3055.
          </Answer>
        </Unit>
        <Unit>
          <Question>What are the freight house hours on Fire Island?</Question>
          <Answer>
            In the off-season, the freight house is only open when the freight
            boat is in town. During the summer season and as our crew fills in,
            regular hours will be posted on our phone line (631.647.3055) and/or
            at the freight houses. For estimated beach times call 631.647.3055.
          </Answer>
        </Unit>
        <Unit>
          <Question>
            How do I address my packages when ordering online?
          </Question>
          <Answer>
            Make sure to include your name and destination. <br />
            <br />
            Example: <strong>Jane Smith – Fair Harbor</strong>
            <br />
            99 Maple Ave.
            <br />
            Bay Shore NY 11706
          </Answer>
        </Unit>
        <Unit>
          <Question>How do I set up a credit card account?</Question>
          <Answer>
            There are three ways to set up a credit card account for freight.
            <ol>
              <li>
                Visit the{' '}
                <a href='https://fireislandfreight.azurewebsites.net/'>
                  Freight Portal
                </a>{' '}
                and follow the prompts to set up an account to include your
                credit card. Log in as new user.
              </li>
              <li>
                Call the Bay Shore freight house (631.647.3055) to set it up
                with the freight office.
              </li>
              <li>
                Come to the freight boat or Bay Shore freight house in person
                with your credit card.
              </li>
            </ol>
          </Answer>
        </Unit>
        <Unit>
          <Question>What do I have access to with a freight account?</Question>
          <Answer>
            After setting up a freight account online
            (https://fireislandfreight.azurewebsites.net/) you will be able to
            add a credit card (recommended), track the freight boat through
            twitter, view your history of shipments and print out labels for
            your freight.
          </Answer>
        </Unit>
        <Unit>
          <Question>
            The freight portal says I already have an account. I don’t
            understand how. How do I log in?
          </Question>
          <Answer>
            We may have your name in our system already so you would be
            considered an existing user. Just call the Bay Shore freight house
            (631.647.3055) and we will be able to look up what email address is
            on account as your username and give you a temporary password that
            you can change once logged in.
          </Answer>
        </Unit>
        <Unit>
          <Question>
            Do we need to call to let you know when we are having a shipment
            delivered?
          </Question>
          <Answer>
            We do ask that if you have a large delivery, furniture, appliances,
            bedding, lumber, etc. to please call (631.647.3055) or email us
            (freight@fireislandferries.com) at least a day before it is due to
            arrive to us.
          </Answer>
        </Unit>
        <Unit>
          <Question>
            Can I ship lumber/ building supplies on the Saturday freight boat?
          </Question>
          <Answer>
            No. Lumber and building supplies are only accepted Monday-Friday
            7:00 AM – 10:00 AM for same day delivery.
          </Answer>
        </Unit>
        <Unit>
          <Question>
            What information do you need from me when I am dropping off freight?
          </Question>
          <Answer>
            Please have everything marked with your last name and destination.
            If you have a credit card account set up with us, have a list of
            what is being dropped off along with your account number.
          </Answer>
        </Unit>
        <Unit>
          <Question>What items can go in the freight houses?</Question>
          <Answer>
            Freight houses are designated for short term holding of smaller
            items such as Amazon, UPS, FedEx shipments and beverage. Bulk
            deliveries and large items including but not limited to furniture,
            appliances, mattresses and bicycles must be scheduled for same day
            pick up. Landscaping, building supplies and perishables will be left
            outside at owner’s risk.
          </Answer>
        </Unit>
        <Unit>
          <Question>
            Do I need to protect my freight or will the freight crew do it for
            me?
          </Question>
          <Answer>
            All freight must be wrapped, boxed, crated or somehow protected in
            order for us to accept it. Otherwise, the Fire Island Ferries will
            not be held responsible for damages.
          </Answer>
        </Unit>
        <Unit>
          <Question>
            What time is someone in Bay Shore until to receive deliveries?
          </Question>
          <Answer>
            Someone is in the Bay Shore freight house until 3:30 PM Monday
            through Friday in the off-season and Saturdays from mid-April
            through mid-September. Commercial deliveries are only accepted
            Monday-Friday 7:00 AM – 3:30 PM and when we are running a Saturday
            freight boat, Saturday 7:00 AM – 10:00 AM.
          </Answer>
        </Unit>
      </div>
    </div>
  </div>
);
